import { Component, OnInit } from '@angular/core';
import { UserService } from '../Services/user.service';
import { CookieService } from 'ngx-cookie-service';
import { AppWideUser, Token } from '../Services/AppUserProfile';
import { SpecialityDTO } from '../Models/Speciality.model';
import { SrubUpService } from '../Services/ScrubUp.service';

declare var swal: any;

@Component({
  selector: 'app-release-speciality',
  templateUrl: './release-speciality.component.html',
  styleUrls: ['./release-speciality.component.scss'],
  providers: [SrubUpService, UserService]
})
export class ReleaseSpecialityComponent implements OnInit {
  specialitiesToRelease: Array<SpecialityDTO>;
  public loading = false;
  getAdminValues: boolean;
  loginUserId: number;
  specialityIdToRelease: number;

  constructor(private userService: UserService, private cookieService: CookieService, private appUser: AppWideUser, private token: Token, private scrubUpService: SrubUpService) {
    if (this.appUser.UserName == undefined && this.token.access_token == undefined || this.appUser.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUser = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.loginUserId = this.appUser.UserId;
    this.getAdminValues = false;
    this.specialitiesToRelease = new Array<SpecialityDTO>();
    this.specialityIdToRelease = -1;
  }

  GetSpecialitiesToRelease() {
    this.loading = true;
    this.scrubUpService.GetSpecialitiesToRelease(this.token).subscribe(x => {
      if (x != null && x != undefined) {
        this.specialitiesToRelease = x;
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  ReleaseToStore() {
   if(this.specialityIdToRelease!=-1)
   {
    swal({
      title: 'Are you sure you want to release this specialty to the App Store?',
      html: '<div style="font-size:18px;text-align:left;margin-left:5%;">Please verify checklist before proceed.<br><br>1. Uploaded 4 Images.<br><br>2. Added Procedures.<br><br>3. Patient Positioning.<br><br>4. Operation Room.<br><br>5. Preparation.<br><br>6. Equipments and Notes.</div>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Yes, release it!',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      this.loading = true;
      this.scrubUpService.ReleaseSpecialityToStore(this.token, this.specialityIdToRelease, this.loginUserId).subscribe(x => {
        if (x == "success") {
          swal({
            title: 'Speciality Released to Store ',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);;
        }
        else {

        }
        this.loading = false;
      },
        error => {
          this.loading = false;
        })
    }).catch(swal.noop);

   }
   
  }

  ngOnInit() {
    this.GetSpecialitiesToRelease();
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/release-speciality/release-speciality.component.ts